<app-divider
  [id]="'activity.rating.anchor' | translate"
  class="activity-reviews__divider--top"
></app-divider>
<section class="activity-reviews">
  <header>
    <h2 class="activity-reviews__title">
      {{ 'reviews.title' | translate }}
    </h2>
    <div class="activity-reviews__inner">
      <div
        class="activity-reviews__global"
        [ngClass]="
          hasReview
            ? 'activity-reviews__global--with-reviews'
            : 'activity-reviews__global--without-reviews'
        "
      >
        <p class="activity-reviews__global global-reviews__title">
          {{ reviewsTranslation }}
        </p>
        <app-vtmn-rating
          *ngIf="hasReview"
          [class]="{ 'activity-reviews__no-reviews': !hasReview }"
          [emphasis]="true"
          [showValue]="hasReview"
          [value]="averageRating"
          [size]="ratingSize.SMALL"
        ></app-vtmn-rating>
        <p
          [ngClass]="[
            hasReview
              ? 'activity-reviews__text--with-reviews'
              : 'activity-reviews__text--without-reviews',
          ]"
          class="activity-reviews__text"
        >
          <ng-container *ngIf="!hasReview">
            {{ 'reviews.no_reviews_text' | translate }}
          </ng-container>
          <ng-container *ngIf="hasReview">
            <vtmn-play-icon
              [name]="iconType?.ThumbUp"
              class="activity-reviews__icon"
            ></vtmn-play-icon>
            {{ recommendationRate | percent }} {{ 'reviews.text' | translate }}
          </ng-container>
        </p>
      </div>
      <ul class="activity-reviews__list" *ngIf="hasReview">
        <li
          class="activity-reviews__list-item"
          *ngFor="let item of averageAttributeRating"
        >
          {{ item.label }}
          <app-vtmn-rating
            [compact]="true"
            [emphasis]="true"
            [showValue]="true"
            [value]="item.value"
            [size]="ratingSize.SMALL"
          ></app-vtmn-rating>
        </li>
      </ul>
    </div>
  </header>
  <app-divider
    *ngIf="hasReview"
    class="activity-reviews__divider"
  ></app-divider>
  <ul *ngIf="hasReview">
    <li *ngFor="let review of reviews">
      <app-activity-reviews-detail
        [review]="review"
      ></app-activity-reviews-detail>
    </li>
  </ul>
  <a
    *ngIf="hasReview"
    app-vtmn-play-button
    class="activity-reviews__show-all-reviews"
    [size]="vtmnPlayButtonSize.MEDIUM"
    [variant]="vtmnPlayButtonVariant.SECONDARY"
    [routerLink]="getActivityReviewsLink() | localize"
  >
    {{ 'reviews.activity_reviews_link' | translate }}
  </a>
</section>
